import { Button } from 'antd'
import { ButtonProps } from 'antd/lib'

import cn from '@/utils/tailwind/cn'

export const CalculationKeyboardButton = ({
  className,
  ...props
}: ButtonProps) => (
  <Button
    className={cn(
      'min-h-9 w-full rounded-none border-transparent bg-gray-100 !p-0',
      '!outline-blue-200 focus:!border-blue-200 active:!border-blue-200',
      'h-full font-bold text-gray-600 hover:!border-blue-300',
      'disabled:border-transparent disabled:bg-gray-100/70 disabled:hover:!border-blue-100',
      className
    )}
    {...props}
  />
)
